import { axios } from '@/config/plugins/axios';

export default function downloadApiFile(url: string, filename: string, type = '') {
	return axios
		.get(url, { responseType: 'blob' })
		.then((response) => {
			if (0 === type.length) {
				type = response.headers['content-type'];
			}
			downloadFile(response.data, filename, type);
		});
}

export function downloadFile(content: any, filename: string, type: string) {
	const blob = new Blob([content], { type: type });

	downloadBlob(blob, filename);
}

export function downloadUTF16CsvFile(content: any, filename: string) {
	let charCode;
	const byteArray = [];

	for (let i = 0; i < content.length; ++i) {
		charCode = content.charCodeAt(i);

		// LE Bytes
		byteArray.push(charCode & 0xff);
		byteArray.push(charCode / 256 >>> 0);
	}

	const blob = new Blob([new Uint8Array(byteArray)], { type: 'text/csv;charset=UTF-16BE;' });

	downloadBlob(blob, filename);
}

function downloadBlob(blob: Blob, filename: string) {
	if (0 < navigator.appVersion.toString().indexOf('.NET')) {
		(window.navigator as any).msSaveOrOpenBlob(blob, filename);
	} else {
		const link = document.createElement('a');
		link.target = '_blank';
		link.style.display = 'none';
		link.rel = 'noopener noreferrer';
		link.href = window.URL.createObjectURL(blob);
		link.download = filename;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		window.URL.revokeObjectURL(link.href);
	}
}
